<template>
  <div class="main">
    <FormWrapper :action="formAction" method="PUT">
      <div class="title-bar">
        <h1 class="mb-0">Edit Email</h1>
        <a class="btn-back" :href="route('admin.emails.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>
      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters pl-4">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>
            <div class="col-12 mb-3">
              <Field
                type="text"
                name="name"
                label="Name"
                :value="email.name"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3">
              <Field
                type="text"
                name="description"
                label="Description"
                :value="email.description"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3">
              <MultiAssignField
                type="text"
                name="cc"
                label="CC Email Addresses"
                :value="email.cc"
              />
            </div>
            <div class="col-12 mb-3">
              <MultiAssignField
                type="text"
                name="bcc"
                label="BCC Email Addresses"
                :value="email.bcc"
              />
            </div>
            <div class="col-12 mb-3">
              <Field
                type="text"
                name="subject"
                label="Subject"
                :value="email.subject"
                validate="required"
              />
            </div>
            <div class="col-12 mb-3">
              <HtmlField
                name="message"
                label="Message"
                :value="email.message"
                validate="required"
                :hideAssetIcons="true"
              />
            </div>
            <div class="col-12">
              <a
                href="#"
                @click.prevent="showSupportedTags()"
                class="btn btn-info"
                >Supported Merge Tags</a
              >
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="text-center">
              <button
                type="submit"
                class="btn btn-success d-inline-block w-50 mb-2"
              >
                Save Changes
              </button>
              <a
                class="btn btn-danger d-inline-block w-50 mb-2"
                :href="route('admin.emails.index')"
                >Cancel & Exit</a
              >
            </div>
            <div class="font-size-sm text-center pt-4">
              <span
                >Last updated on
                {{ email.updated_at | moment("MM/DD/YYYY") }}</span
              >
              <span>at {{ email.updated_at | moment("h:mma") }}</span>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import SupportedTagsModal from "./partials/SupportedTagsModal";
export default {
  mixins: [DisplaysAlerts],
  props: {
    email: { type: Object, required: true },
  },
  computed: {
    formAction() {
      return this.route("admin.emails.update", {
        email: this.email.id,
      });
    },
  },
  methods: {
    showSupportedTags() {
      this.$modal(SupportedTagsModal, { email: this.email })
        .then(() => {})
        .catch(() => {});
    },
  },
};
</script>